import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90d0334a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "training"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "question-count" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "question" }
const _hoisted_6 = { class: "bottom" }

import { ref } from "vue";
import { Training } from "@/types/training/Training";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { computed } from "vue";
import FormCheckboxGroup from "@/components/molecules/form/FormCheckboxGroup.vue";
import FormRadioGroup from "@/components/molecules/form/FormRadioGroup.vue";
import NextModal from "./NextModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Question',
  props: {
  training: {
    type: Object as () => Training,
    required: true
  },
  transitionDisabled: {
    type: Boolean,
    default: false
  }
},
  emits: {
  finish: () => true
},
  setup(__props, { emit }) {

const props = __props;





const currentPage = ref(0);
const nextModal = ref<InstanceType<typeof NextModal> | null>(null);
const selectedMAChoiceIds = ref<string[]>([]);
const selectedSAChoiceId = ref("");
const isChoiceSelected = computed(() => {
  if (props.training.questions[currentPage.value].type === "SA") {
    return selectedSAChoiceId.value !== "";
  } else {
    return selectedMAChoiceIds.value.length > 0;
  }
});

const currentQuestion = computed(() => {
  return props.training.questions[currentPage.value];
});
const choiceOptions = computed(() => {
  return currentQuestion.value?.choices.map(c => ({
    value: c.id.toString(),
    text: c.text
  }));
});

function isAnswerCorrect(): boolean {
  const question = currentQuestion.value;
  if (!question) return false;

  if (question.type === "SA") {
    return (
      question.choices.find(c => c.isCorrect)?.id.toString() ===
      selectedSAChoiceId.value
    );
  } else {
    const correctChoices = question.choices
      .filter(c => c.isCorrect)
      .map(c => c.id.toString());
    return (
      selectedMAChoiceIds.value.length === correctChoices.length &&
      selectedMAChoiceIds.value.every(v => correctChoices.includes(v))
    );
  }
}

async function onClickNext() {
  if (!isAnswerCorrect()) {
    await nextModal.value?.show(false);
    return;
  }

  await nextModal.value?.show(true);

  // プレビューの場合は遷移を無効にする
  if (props.transitionDisabled) return;

  if (currentPage.value === props.training.questions.length - 1) {
    emit("finish");
    return;
  }

  currentPage.value++;
  selectedMAChoiceIds.value = [];
  selectedSAChoiceId.value = "";
}

return (_ctx: any,_cache: any) => {
  return (__props.training && currentQuestion.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", null, _toDisplayString(__props.training.title), 1),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_3, _toDisplayString(currentPage.value + 1) + "/" + _toDisplayString(__props.training.questions.length) + "問\n      ", 1)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(currentQuestion.value.text), 1),
          _createTextVNode(),
          _createElementVNode("div", {
            class: _normalizeClass(["choices", {
          sa: currentQuestion.value.type === 'SA',
          ma: currentQuestion.value.type === 'MA'
        }])
          }, [
            (currentQuestion.value.type === 'MA')
              ? (_openBlock(), _createBlock(FormCheckboxGroup, {
                  key: 0,
                  options: choiceOptions.value,
                  modelValue: selectedMAChoiceIds.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMAChoiceIds).value = $event)),
                  variant: "stacked"
                }, null, 8, ["options", "modelValue"]))
              : (_openBlock(), _createBlock(FormRadioGroup, {
                  key: 1,
                  name: currentQuestion.value.id.toString(),
                  modelValue: selectedSAChoiceId.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSAChoiceId).value = $event)),
                  options: choiceOptions.value,
                  "flex-direction": "column",
                  variant: "stacked"
                }, null, 8, ["name", "modelValue", "options"]))
          ], 2)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(AppButton, {
            onClick: onClickNext,
            class: "next-button",
            disabled: !isChoiceSelected.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ], undefined, true),
            _: 1
          }, 8, ["disabled"]),
          _createTextVNode(),
          _createVNode(NextModal, {
            ref_key: "nextModal",
            ref: nextModal
          }, null, 512)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})